import classNames from 'classnames';

interface GridLinesProps {
	rows: number;
	cols: number;
	cellSize: number;
}

const GridLines = ({ rows, cols, cellSize }: GridLinesProps) => {
	return (
		<div className="letter-party-game__grid">
			{Array.from({ length: rows }).map((_, index) => (
				<div
					key={`h-${index}`}
					className={classNames(
						'letter-party-game__grid-line',
						'letter-party-game__grid-line--horizontal',
						`letter-party-game__grid-line--horizontal-${index}`,
					)}
					style={{ top: index * cellSize }}
				/>
			))}
			{Array.from({ length: cols }).map((_, index) => (
				<div
					key={`v-${index}`}
					className={classNames(
						'letter-party-game__grid-line',
						'letter-party-game__grid-line--vertical',
						`letter-party-game__grid-line--vertical-${index}`,
					)}
					style={{ left: index * cellSize }}
				/>
			))}
		</div>
	);
};

export default GridLines;
